import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ProjectId } from 'api/models';
import { FetchStatus } from 'data/core';
import { saveTasks } from 'data/tasks/slice';
import { useProjectTasksQuery } from 'queries/task';

export const useProjectTasks = (projectId: ProjectId): void => {
  const dispatch = useDispatch();

  const { data } = useProjectTasksQuery(projectId, {
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (data != null) {
      dispatch(saveTasks({ data, fetchStatus: FetchStatus.Loaded }));
    }
  }, [data, dispatch]);
};
